import type { ApiTmpStorageId } from '#/api/types/ApiTypedId';
import { del } from '#/utils/http/del';

export function apiDeleteTmpStorage(tmpStorageId: ApiTmpStorageId) {
  return del(`/data/tmp-storage/${tmpStorageId}`);
}
